import React from "react";

export const IsMenuOpenedContext = React.createContext(false);
export const DismissMenuContext = React.createContext(false);
